export default __webpack_public_path__ + "static/media/install-chat-widget5.384a09b8.JPG";